import { render } from "./MdTable.vue?vue&type=template&id=63abc718"
import script from "./MdTable.vue?vue&type=script&lang=js"
export * from "./MdTable.vue?vue&type=script&lang=js"
script.render = render

export default script